module.exports = __webpack_public_path__ + "img/40_23.f0da6974.png";